module.exports = __webpack_public_path__ + "static/img/05.7f17e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/05.jpg
// module id = Hh0S
// module chunks = 0